import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Hook personalizado para detectar mobile
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return isMobile;
};
  // Skills logos (copiado de Resume.jsx)
  const skillLogos = [
    { src: "/images/skills/wordpress.png", alt: "WordPress" },
    { src: "/images/skills/woocommerce.png", alt: "WooCommerce" },
    { src: "/images/skills/acf.png", alt: "ACF" },
    { src: "/images/skills/shopify.png", alt: "Shopify" },
    { src: "/images/skills/javascript.png", alt: "Liquid" },
    { src: "/images/skills/whmcpanel.png", alt: "WHM/cPanel" },
    { src: "/images/skills/html.png", alt: "HTML" },
    { src: "/images/skills/reactjs.png", alt: "React JS" },
    { src: "/images/skills/nextjs.png", alt: "Next JS" },
    { src: "/images/skills/nodejs.png", alt: "Node" },
  ];

  const sliderSettings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 6000,
    infinite: true,
    arrows: false,
    pauseOnHover: false,
    cssEase: "linear",
    swipe: true,
    draggable: true,
  centerMode: true,
  variableWidth: true,
  };

  // Services slider settings para mobile
  const servicesSliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    cssEase: "ease-in-out"
  };

const Services = ({ classicHeader, darkTheme }) => {
  const isMobile = useIsMobile();
  
  // services details
  const services = [
    {
      name: "Web Development",
  desc: "Institutional websites, online stores, and eLearning platforms. Custom WordPress development focused on performance, design, and scalability.",
      icon: "fas fa-desktop",
    },
    {
      name: "AI Automation",
  desc: "Automations for processes, content, CRM, and integrations. AI tools that simplify workflows and optimize productivity.",
      icon: "fas fa-robot",
    },
    {
      name: "Maintenance & Support",
  desc: "Plugin and theme updates, backups, bug fixing, and performance monitoring. Full technical support to keep your site stable and secure.",
      icon: "fas fa-tools",
    },
    {
      name: "Hosting Services",
  desc: "Website hosting, storage management, and professional email setup. Server optimization, DNS configuration, and migration assistance.",
      icon: "fas fa-server",
    },
    {
      name: "Web Security",
  desc: "Malware cleanup, firewall setup, and SSL implementation. Protection, monitoring, and hardening for secure environments.",
      icon: "fas fa-shield-alt",
    },
    {
      name: "Tech Consulting",
  desc: "Digital strategy, system architecture, and technical auditing. Guidance for scalable, efficient, and future-ready web solutions.",
      icon: "fas fa-brain",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div data-reveal className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        {isMobile ? (
          <div data-reveal className="services-mobile-slider">
            <Slider {...servicesSliderSettings}>
              {Array.from({ length: Math.ceil(services.length / 2) }, (_, slideIndex) => (
                <div key={slideIndex} className="slide-content">
                  <div className="row">
                    <div className="col-lg-11 mx-auto">
                      <div className="row">
                        {services
                          .slice(slideIndex * 2, slideIndex * 2 + 2)
                          .map((service, index) => (
                            <div className="col-12 mb-4" key={slideIndex * 2 + index}>
                              <div className="featured-box style-3">
                                <div
                                  className={
                                    "featured-box-icon text-primary shadow-sm rounded " +
                                    (darkTheme ? "bg-dark-1" : "bg-white")
                                  }
                                >
                                  <i className={service.icon} />
                                </div>
                                <div className="featured-box-content">
                                  <h3 className={darkTheme ? "text-white" : ""}>
                                    {service.name}
                                  </h3>
                                  <p
                                    className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                                  >
                                    {service.desc}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : (
          /* Desktop Grid */
          <div className="row">
            <div className="col-lg-11 mx-auto">
              <div className="row">
                {services.length > 0 &&
                  services.map((service, index) => (
                    <div className="col-md-6" key={index}>
                      <div data-reveal data-reveal-delay={(index % 2) * 0.1} className="featured-box style-3 mb-5">
                        <div
                          className={
                            "featured-box-icon text-primary  shadow-sm rounded " +
                            (darkTheme ? "bg-dark-1" : "bg-white")
                          }
                        >
                          <i className={service.icon} />
                        </div>
                        <h3 className={darkTheme ? "text-white" : ""}>
                          {service.name}
                        </h3>
                        <p
                          className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                        >
                          {service.desc}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {/* content end */}
        
        {/* Skills Section */}
        <div data-reveal className="skills-section mt-5">
          <div className="skills-grid">
            <style>{`
              .skill-pill {
                border: none;
                transition: all 0.3s ease;
                cursor: default;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                font-weight: 500;
                color: white !important;
                font-size: 13px;
              }
              .skill-pill:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0,0,0,0.2);
              }
              .skill-pill.administrative {
                background-color: #6610f2;
              }
              .skill-pill.technical {
                background-color: #0ea075;
              }
              .skill-pill.dev-tools {
                background-color: #6c757d;
              }
              .skills-grid .row {
                margin: 0;
                row-gap: 12px;
              }
            `}</style>
            <div className="row gx-2 gy-0">
              {/* Administrative Skills - Indigo */}
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  ClickUp
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Trello
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Asana
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Google Suite
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  MS Teams
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Photoshop
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Illustrator
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Adobe XD
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Figma
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill administrative px-3 py-1 rounded-pill">
                  Slack
                </span>
              </div>
              
              {/* Technical Programming Skills - Teal */}
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  WordPress
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  React.js
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  JavaScript
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  PHP
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  Node.js
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  CSS/SCSS
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  MySQL
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  WooCommerce
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  Shopify
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  Liquid
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  HeadLess
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  Tailwind
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  HTML
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill technical px-3 py-1 rounded-pill">
                  Bootstrap
                </span>
              </div>
              
              {/* Development Tools - Secondary */}
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  GitHub
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  VS Code
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  Copilot
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  Git
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  Docker
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  Linux
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  WPEngine
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  CPanel
                </span>
              </div>
              <div className="col-auto">
                <span className="skill-pill dev-tools px-3 py-1 rounded-pill">
                  WHM
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
